import { isElementInViewport } from './isElementInViewport.js';

function handleOpen(detail, selector) {
  if (!detail.open) return;

  const siblings = detail.parentNode.querySelectorAll(selector);
  siblings.forEach((sibling) => {
    if (sibling === detail) return;
    sibling.removeAttribute('open');
  });

  const summary = detail.querySelector('summary');
  setTimeout(() => {
    if (!isElementInViewport(summary)) {
      summary.scrollTo();
    }
  }, 10);
}

export function detailsGroup(selector = '.details-group details', alwaysOpen = true) {
  const details = document.querySelectorAll(selector);
  details.forEach((detail) => {
    detail.addEventListener('toggle', (event) => handleOpen(event.target, selector, alwaysOpen));

    if (alwaysOpen) {
      detail.querySelector('summary').addEventListener('click', (e) => {
        if (detail.open) {
          e.preventDefault();
        }
      });
    }
  });
}
